import type { PagoPaquete } from './appTypes';

/**
 * "Por cobrar": en pantalla se ingresa el monto POR COBRAR, pero el backend guarda el monto ya
 * pagado (`monto_pagado`) y el conductor calcula el saldo como total − pagado.
 */

/** Monto por cobrar a mostrar: el ingresado, o total − pagado, o el total de la factura. */
export function montoPorCobrarDe(pago: PagoPaquete | undefined, total?: number | null): number | undefined {
  if (!pago || pago.tipo !== 'parcial') return undefined;
  if (typeof pago.montoPorCobrar === 'number') return pago.montoPorCobrar;
  if (typeof total !== 'number' || Number.isNaN(total)) return undefined;
  return Number(Math.max(total - (pago.montoPagado ?? 0), 0).toFixed(2));
}

/** Validación del monto por cobrar frente al total de la factura (si se conoce). */
export function validarMontoPorCobrar(pago: PagoPaquete | undefined, total?: number | null): string | null {
  if (!pago || pago.tipo !== 'parcial') return null;
  const porCobrar = montoPorCobrarDe(pago, total);
  if (typeof porCobrar !== 'number' || porCobrar <= 0) return 'Ingresa el monto por cobrar (mayor que 0).';
  if (typeof total === 'number' && porCobrar > total + 0.005) return 'El monto por cobrar no puede ser mayor al valor total de la factura.';
  return null;
}

/** Pago listo para guardar: convierte el monto por cobrar en monto pagado (total − por cobrar). */
export function pagoParaGuardar(pago: PagoPaquete | undefined, total?: number | null): PagoPaquete | undefined {
  if (!pago || pago.tipo !== 'parcial') return pago;
  const { montoPorCobrar, ...resto } = pago;
  if (typeof montoPorCobrar !== 'number' || typeof total !== 'number' || Number.isNaN(total)) {
    return { ...resto, montoPagado: resto.montoPagado ?? 0 };
  }
  return { ...resto, montoPagado: Number(Math.max(total - montoPorCobrar, 0).toFixed(2)) };
}
